import { AlertTriangle, Server } from 'lucide-react'
import React from 'react'

const Error500: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          {/* 错误图标 */}
          <div className="mx-auto h-32 w-32 bg-red-100 rounded-full flex items-center justify-center mb-6">
            <Server className="h-16 w-16 text-red-600" />
          </div>

          {/* 错误代码 */}
          <h1 className="text-6xl font-bold text-gray-900 mb-4">500</h1>

          {/* 错误标题 */}
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            服务器内部错误
          </h2>

          {/* 错误描述 */}
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
            <div className="flex">
              <AlertTriangle className="h-5 w-5 text-yellow-400 mr-3 flex-shrink-0 mt-0.5" />
              <div className="text-left">
                <p className="text-sm text-yellow-800">
                  抱歉，服务器遇到了一个内部错误，无法完成您的请求。
                </p>
                <p className="text-xs text-yellow-600 mt-2">
                  我们的技术团队已经收到错误通知，正在努力修复此问题。
                </p>
              </div>
            </div>
          </div>

          {/* 联系信息 */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              如果问题持续存在，请联系技术支持
            </p>
            <p className="text-xs text-gray-400 mt-1">
              错误代码: HTTP 500 - Internal Server Error
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Error500
